import Backbone from 'backbone'
import template from './display-options-form.hbs'
import metricsTableOptions from './metrics-table-options.hbs'
import dropdown from 'scoreboard/components/dropdown'
import _ from 'lodash'
import formHelper from 'scoreboard/components/form-helper'
import BusyButton from 'scoreboard/components/busy-button'
import config from 'scoreboard/components/config'
import select from 'scoreboard-select'

var DisplayOptionsForm = Backbone.View.extend({

	tagName: 'form',

	className: 'display-options-form',

	events: {
		'submit': 'submit',
		'click .cancel': 'cancel'
	},

	initialize: function(options) {
		this.options = options
	},

	render: function() {
		this.$el.empty().append(template({
			metricsTableOptions: metricsTableOptions()
		}))
		dropdown.values(this.$('.periods'), _.range(1, 25))
		formHelper.writeToDom(this.options.data, this.el)
		select(this.el.querySelectorAll('select'))

		if (!config.scoresVisible) {
			this.$('[name=showScore]').closest('label').hide()
		}
		return this
	},

	submit: function(e) {
		e.preventDefault()
		this.$el.addClass('is-submitting-form') // Add manually because this doesn't use the formView
		new BusyButton({ el: this.$('.button-primary') }).loading()

		this.trigger('done', formHelper.readFromDom(this.el))
	},

	cancel: function() {
		this.trigger('cancel')
	}

})

export default DisplayOptionsForm

DisplayOptionsForm.__filename__ = 'scorecards/metrics/display-options-form.js'
